import {
  CancelablePromise,
  PaginatedReceiptList,
  Receipt,
  ReceiptStatusEnum
} from '@pxtra-client-lib-legacy/gen';
import { PxtraApiClientLegacy } from '@pxtra-client-lib-legacy';
import AuthenticationStore from '../authenticationStore';
import CompanyStore from '../companyStore';
import { NavigateFunction } from 'react-router';
import { TFunction } from 'i18next';
import ReceiptStore from './details';
import { ReceiptBenefitType, ReceiptsViewModel } from '../../viewModels/receipts';
import { BaseListRequestBody, ListStore } from '../base/ListStore';

export type ReceiptsFilterModel = {
  amount?: number;
  benefit?: Array<`${ReceiptBenefitType}`>;
  company?: string;
  dateAfter?: string;
  dateBefore?: string;
  employee?: string;
  employeeName?: string;
  note?: string;
  status?: ReceiptStatusEnum;
  search?: string;
};

export class ReceiptListStore extends ListStore<
  ReceiptsViewModel,
  ReceiptsFilterModel,
  PaginatedReceiptList,
  Receipt
> {
  constructor(
    apiClient: PxtraApiClientLegacy,
    authenticationStore: AuthenticationStore,
    private receiptStore: ReceiptStore,
    private companyStore: CompanyStore,
    private navigate: NavigateFunction,
    private translate: TFunction
  ) {
    super(apiClient, authenticationStore);
  }

  private get company() {
    if (!this.companyStore.company) throw Error('No company selected');
    return this.companyStore.company;
  }

  protected mapItem(item: Receipt): ReceiptsViewModel {
    return new ReceiptsViewModel(item, this.receiptStore, this.translate, this.navigate);
  }
  protected _fetch(
    baseBody: BaseListRequestBody<ReceiptsFilterModel>
  ): CancelablePromise<PaginatedReceiptList> {
    return this.apiClient.receipts.receiptsList({
      company: this.company.id,
      ...baseBody
    });
  }
}
